module.exports = " <div class=modal> <div class=disclaimer__container> <div class=block> <div class=block__header> <h2 class=block__title>{{ getResource('RicohImagingDisclaimerTitle') }}</h2> </div> <div class=\"block__content block__content--disclaimer\"> {{{ getResource('RicohImagingDisclaimerText') }}} <div> <button class=button v-on:click=approveDisclaimer>Approve</button> </div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/app/navigation/Disclaimer.vue
// module id = 160
// module chunks = 0